import axios from 'axios'
import {_this_} from '@/main.js' // 加载等待
import qs from 'qs'
import Vue from 'vue'

//status管理
function stateManagementErr(err) {
  switch (err) {
    case 400:
      // console.log(400 + '请检查参数')
      break
    case 401:
      // _this_.$router.push({ path: '/login' })
      break
    case 404:
      // console.log(404 + '请确认接口名称')
      break
    case 405:
      // console.log(405 + '请检查请求type')
      break
    case 403:
      alert("您没有操作权限!")
      break
    default:
      alert('错误代码: ' + err.status || '网络崩溃')
      break
  }
}

// 加载动画
// let options = {}

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;

// 开启loading
function startLoading() {
  loading = Vue.prototype.$loading({
    // lock: true,
    text: "Loading...",
    background: 'rgba(0, 0, 0, 0.7)',
    target: document.querySelector('.loading-area')//设置加载动画区域
  });
}

// 关闭loading
function endLoading() {
  loading.close();
}

// options = {
//   // lock: true,
//   text: '正在加载...',
//   target: document.querySelector('.loading-area'),//设置加载动画区域
//   // spinner: 'el-icon-loading',
//   // background: 'rgba(0, 0, 0, 0.7)'
// } // loading 配置

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  // console.log(needLoadingRequestCount,'needLoadingRequestCount');
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  // 新加判断
  if (needLoadingRequestCount === 2) {
    endLoading();
  }
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

let flag

// 请求拦截
axios.interceptors.request.use(config => {

  if (config.url.split('/')[config.url.split('/').length - 1] !== 'unique_user') {
    showFullScreenLoading();
  }
  return config
}, err => {
  // flag.close()
  tryHideFullScreenLoading();
  stateManagementErr(err)
  return Promise.resolve(err)
})
// 响应拦截
axios.interceptors.response.use(response => {
  // if (flag) {
  //   flag.close()
  //   return Promise.resolve(response)
  // }
  tryHideFullScreenLoading();
  return Promise.resolve(response)
  // stateManagementErr(response)

  //
}, err => {
  // flag.close();
  tryHideFullScreenLoading();
  stateManagementErr(err.response.status);
  Promise.resolve(err.response)
});

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

var token = 'JWT ' + window.sessionStorage.token;
// var user_name_ = '';

// start 线上
const baseUrl = 'https://crmpy.datahoop.cn';
//const baseUrl2 = 'https://py.datahoop.cn';
const baseUrl2 = 'https://ai.datahoop.cn/v4be';
// const baseUrl3 = 'https://aiservice.datahoop.cn/v4be';
const baseUrl3 = 'http://172.17.0.51:9009/v4be';
// end   线上




// const baseUrl = 'http://172.17.0.39:8001';

// const baseUrl = 'http://140.143.136.232:9000';
// const baseUrl2 = 'http://140.143.136.232:9000';

function GetAxios({url, data = {}, type}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl + url;
  var responseType = 'json';
  if (type) {
    responseType = type
  }
  // return axios.get(needUrl, { params: data, headers: { 'Authorization': token } }).then((res) => {
  return axios.get(needUrl, {
    params: data, responseType: responseType, paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }, headers: {'Authorization': token}
  }).then((res) => {
    // return axios.get(needUrl, {params: data}).then((res) => {
    if (url === '/push/unique_user') {
      return res.data
    } else {
      if (res.status === 200 && res.data.status) {
        return res.data
      } else {
        return res.data // 错误信息
        // alert(res.data.msg + ' ' + res.data.status)
      }
    }
  }).catch((err) => {
    return err
  })
}


function GetAxios1({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl + url;
  // return axios.post(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
    return axios.get(needUrl, { params: data, headers: { 'Authorization': token } }).then((res) => {
    if (url === '/push/unique_user') {
      return res.data
    } else {
      if (res.status === 200 && res.data.status) {
        return res.data
      } else {
        return res.data // 错误信息
        // alert(res.data.msg + ' ' + res.data.status)
      }
    }
  }).catch((err) => {
    return err
  })
}

function GetAxios2({url, data = {}, type}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl2 + url;
  var responseType = 'json';
  if (type) {
    responseType = type
  }
  // return axios.get(needUrl, { params: data, headers: { 'Authorization': token } }).then((res) => {
  return axios.get(needUrl, {
    params: data, responseType: responseType, paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  }).then((res) => {
    // return axios.get(needUrl, {params: data}).then((res) => {
    if (url === '/push/unique_user') {
      return res.data
    } else {
      if (res.status === 200 && res.data.status) {
        return res.data
      } else {
        return res.data // 错误信息
        // alert(res.data.msg + ' ' + res.data.status)
      }
    }
  }).catch((err) => {
    return err
  })
}
function GetAxios3({url, data = {}, type}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl3 + url;
  var responseType = 'json';
  if (type) {
    responseType = type
  }
  // return axios.get(needUrl, { params: data, headers: { 'Authorization': token } }).then((res) => {
  return axios.get(needUrl, {
    params: data, responseType: responseType, paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  }).then((res) => {
    // return axios.get(needUrl, {params: data}).then((res) => {
    if (url === '/push/unique_user') {
      return res.data
    } else {
      if (res.status === 200 && res.data.status) {
        return res.data
      } else {
        return res.data // 错误信息
        // alert(res.data.msg + ' ' + res.data.status)
      }
    }
  }).catch((err) => {
    return err
  })
}

// post请求封装
function PostAxios({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl + url;
  // return axios.post(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
  return axios.post(needUrl, data, {headers: {'Authorization': token}}).then((res) => {
    // // console.log(res, 11111111111111)
    if (res.status === 200 && res.data.status) {
      return res.data
    } else {
      return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}


function PostAxios2({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl2 + url;
  // return axios.post(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
  return axios.post(needUrl, data).then((res) => {
    // // console.log(res, 11111111111111)
    if (res.status === 200 && res.data.status) {
      return res.data
    } else {
      return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}
function PostAxios3({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token;
  const needUrl = baseUrl3 + url;
  // return axios.post(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
  return axios.post(needUrl, data).then((res) => {
    // // console.log(res, 11111111111111)
    if (res.status === 200 && res.data.status) {
      return res.data
    } else {
      return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}

// DELETE请求封装
function DeleteAxios({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token
  const needUrl = baseUrl + url;
  return axios.delete(needUrl, {data}, {headers: {'Authorization': token}}).then((res) => {
    if (res.status === 200 && res.data.status) {
      return res.data
    } else {
      return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}


// PUT请求封装
function PutAxios({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token
  const needUrl = baseUrl + url
  // return axios.put(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
  return axios.put(needUrl, data, {headers: {'Authorization': token}}).then((res) => {
    if (res.status === 200 && res.data.status) {
      return res.data
    } else {
      return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}






// PUT请求封装  新添加
function PutAxios2({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token
  const needUrl = baseUrl2 + url
  // console.log(needUrl);
  // return axios.put(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
  return axios.put(needUrl, data).then((res) => {
    // console.log(res);
    if (res.data.code === 200 ) {
      // console.log(res.data);
      return res.data
    } else {
      // console.log('hehe');
      // return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}


// PUT请求封装  新添加
function PutAxios3({url, data = {}}) {
  var token = 'JWT ' + window.sessionStorage.token
  const needUrl = baseUrl2 + url
  // console.log(needUrl);
  // return axios.put(needUrl, data, { headers: { 'Authorization': token } }).then((res) => {
  return axios.put(needUrl, data).then((res) => {
    // console.log(res);
    if (res.data.code === 200 ) {
      // console.log(res.data);
      return res.data
    } else {
      // console.log('hehe');
      // return res.data // 错误信息
      // alert(res.data.msg + ' ' + res.data.status)
    }
  }).catch((err) => {
    return err
  })
}








// 根据value值对应的key
function findKey(obj, val, compare = (a, b) => a === b) {
  // var length = val.length - 3
  var houzhui = ['add', 'edt'] // 二级路由命名: 一级路由加 + 尾缀,
  var isAdd = val.substr(-3, 3) // 截取尾缀
  if (houzhui.indexOf(isAdd) !== -1) { // 防止二级页面因为刷新找不到路由
    val = val.substr(0, val.length - 3)
  }
  return Object.keys(obj).find(k => compare(obj[k], val))
}

// 空值 空返回false
function judgeNull(obj) {
  var flag = true
  for (var key in obj) {
    if (obj[key] === '' || obj[key] === null) {
      flag = false
      break
    }
  }
  return flag
}

// 循环判断值是否为空
function isNull(obj) {
  for (var i in obj) {
    if (!obj[i] && obj[i] === '') {
      delete obj[i]
    }
  }
  return obj;
}

// 获取当前时间
function getNowTime(type = 1, whatDate) { // 默认全部显示, whatDate: 是否设置时间-空获取当前时间
                                          // 1, yyyy-MM-dd hh:mm:ss
                                          // 2, yyyy-MM-dd
                                          // 3, hh:mm:ss
  var nowDate = whatDate ? (new Date(whatDate)) : (new Date())

  var nowyear = nowDate.getFullYear() // 年
  var nowMonth = nowDate.getMonth() + 1 // 月
  var nowday = nowDate.getDate() // 日

  var nowhh = nowDate.getHours() // 时
  var nowmm = nowDate.getMinutes() // 分
  var nowss = nowDate.getSeconds() // 秒

  var yMd = nowyear + '-' + (nowMonth > 9 ? nowMonth : '0' + nowMonth) + '-' + (nowday > 9 ? nowday : '0' + nowday)
  var hms = (nowhh > 9 ? nowhh : '0' + nowhh) + ':' + (nowmm > 9 ? nowmm : '0' + nowmm) + ':' + (nowss > 9 ? nowss : '0' + nowss)

  return [yMd + ' ' + hms, yMd, hms][type - 1]
}

const typeArr = ['CPDA教材', 'CPDA讲义', 'CDA教材', '礼品', '证书', '超星账号', '其他'];
const statusArr = ['未审核', '试用期', '正常', '续签', '审核未通过', '试用期延期', '到期', '续签未审核'];
const statusArrS = ['未审核', '试用期', {300: '正常'}, '续签', '审核未通过', '试用期延期', '到期', '续签未审核', '部门审核通过'];
// const departmentArr = ['总经办', '人事行政处', '运营中心', '客服处', '科研中心', '数据中心', '财务处', '市场处', '会员处', '长沙理工'];
const departmentArr = ["管理员", "会长办公室", "人事行政处", "会员处", "运营中心", "客服处", "市场处", "科研中心", "数据中心", "秘书处", "财务处"];
const apply_purposeArr = ['学员领用', '活动领用', '内部领用', '月度盈亏', '渠道样书'];
export {
  GetAxios,
  GetAxios1,
  GetAxios2,
  GetAxios3,
  PostAxios,
  PostAxios2,
  PostAxios3,
  DeleteAxios,
  PutAxios,
  PutAxios2,
  PutAxios3,
  findKey,
  baseUrl,
  judgeNull,
  getNowTime,
  isNull,
  typeArr,
  statusArr,
  departmentArr,
  apply_purposeArr,
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = /sA3
// module chunks = 190